module.exports = __webpack_public_path__ + "static/media/bg.c2863ebd.jpg";